/**
 * Store logo URL — CMS header logo with static asset fallback.
 */
import logoImg from '@/assets/logo.png'
import { useCmsHeader } from '@/hooks/useCmsHeader'

export function useStoreLogo(): string {
  const { headerConfig } = useCmsHeader()
  return headerConfig?.logo_url ?? logoImg
}
